import { render } from "./Education.vue?vue&type=template&id=4fcad006&ts=true"
import script from "./Education.vue?vue&type=script&lang=ts"
export * from "./Education.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__